module.exports = __webpack_public_path__ + "static/media/is.7bb7e2d9.webp";